module.exports = __webpack_public_path__ + "img/Hyrma white.7adaab2c.svg";